import { useEffect, useState } from "react";
import { fetchServiceFee } from "@/services/fee";

interface ServiceFeeState {
  serviceChargeAmount: number;
  serviceChargePaidBy: string;
  loading: boolean;
}

export function useServiceFee(): ServiceFeeState {
  const [serviceChargeAmount, setServiceChargeAmount] = useState(0);
  const [serviceChargePaidBy, setServiceChargePaidBy] = useState("Employer");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchServiceFee()
      .then((data) => {
        if (cancelled) return;
        setServiceChargeAmount((data.serviceChargeAmountCents ?? 0) / 100);
        setServiceChargePaidBy(data.serviceChargePaidBy || "Employer");
      })
      .catch(() => {
        if (cancelled) return;
        setServiceChargeAmount(0);
        setServiceChargePaidBy("Employer");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { serviceChargeAmount, serviceChargePaidBy, loading };
}
